<template>
    <span>
        <ForcastButton :size="'m'" @click="isActive = true;" :disabled="forecast.status === FORECAST_STATUS.DRAFT">view</ForcastButton>
        <ItemQuantitiesModal v-if="isActive" :item="item" :forecast="forecast" @closed="isActive = false;" />
    </span>
</template>
<script>
import ItemQuantitiesModal from "@/components/forecasts/elements/catalogue/ItemQuantitiesModal";
import { FORECAST_STATUS } from "@/components/forecasts/constants";
import ForcastButton from "@/components/forecasts/elements/form/ForcastButton";

export default {
    components: { ForcastButton, ItemQuantitiesModal },
    props: {
        item: {
            type: Object,
            required: true
        },
        forecast: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isActive: false,
            FORECAST_STATUS
        };
    }
};
</script>



// WEBPACK FOOTER //
// ItemQuantitiesButton.vue?0895ddf1